import React,{useState} from "react";
import './app.scss'
import Intro from "./components/intro/Intro";
import Portfolio from "./components/portfolio/Portfolio";
import Topbar from "./components/topbar/Topbar";

import Menu from "./components/menu/Menu";

function App() {
const [menuOpen, setMenuOpen]  = useState(false);



  return (
    <div className="app">
     
     <Topbar open={menuOpen} click={setMenuOpen}/>
     <Menu open={menuOpen} click={setMenuOpen}/>
     <div className='sections'>
       <Intro/>
       <Portfolio/>
     </div>
     {/* section- intro- portfolio page */}
    </div>
  );
}

export default App;
